export enum UserServiceUserType {
  Admin = 'ADMIN',
  Agency = 'AGENCY',
  OrganizationAdmin = 'ORGANIZATION_ADMIN',
  TenantAdmin = 'TENANT_ADMIN',
  User = 'USER',
  Zalo = 'ZALO',
}

export enum UserServiceGender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
}

export enum UserServiceSocialProviders {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Apple = 'APPLE',
}

export enum UserServiceUserStatusGqlOutput {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED',
  Pending = 'PENDING',
}

export type UserServiceUserGqlOutput = {
  avatarUrl?: string
  birthDate?: string
  createdAt?: string
  email?: string
  failedLoginAttempts?: number
  firstName?: string
  fullName?: string
  gender?: UserServiceGender
  id: string
  lastActive?: string
  lastName?: string
  organizationId?: string
  password?: string
  phoneNumber?: string
  prefix?: string
  resetToken?: string
  resetTokenExpiry?: string
  socialProviders?: UserServiceSocialProviders
  status: UserServiceUserStatusGqlOutput
  tenantId?: string
  type: UserServiceUserType
  updatedAt?: string
  verificationCode?: string
  zaloId?: string
  zaloOAId?: string
}
